import { BsBarChart, BsGear, BsInfoCircle, BsArrowClockwise } from 'react-icons/bs';
import styles from './Header.module.scss';

const Header = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
  onNewGame,
}) => {
  return (
    <header className={styles.header}>
      <a href="https://fwt-gamelab.com" className={styles.brand} title="FWT GameLab">
        <span className={styles.dot} />
        <span className={styles.fwt}>FWT</span>
      </a>
      <span className={styles.badge}>EXPERIMENT</span>
      <div className={styles.sep} />
      <h1 className={styles.title}>Wordle</h1>

      <div className={styles.right}>
        <p className={styles.hint}>Guess the hidden word in 6 tries</p>
        <button onClick={() => setIsInfoModalOpen(true)} title="How to play" className={styles.iconBtn}>
          <BsInfoCircle size="1.4rem" />
        </button>
        <button onClick={onNewGame} title="New game" className={styles.iconBtn}>
          <BsArrowClockwise size="1.4rem" />
        </button>
        <button onClick={() => setIsSettingsModalOpen(true)} title="Settings" className={styles.iconBtn}>
          <BsGear size="1.4rem" />
        </button>
        <button onClick={() => setIsStatsModalOpen(true)} title="Statistics" className={styles.iconBtn}>
          <BsBarChart size="1.4rem" />
        </button>
      </div>
    </header>
  );
};

export default Header;
